import React, { useMemo } from "react";
import {
  Home,
  School,
  Users,
  BookOpen,
  ShoppingCart,
  Briefcase,
  Building2,
  Settings,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "../../lib/utils";
import { useViewMode } from "../../client/contexts/ViewModeContext";

const ICONS = {
  users: Users,
  book: BookOpen,
  school: School,
  cart: ShoppingCart,
  briefcase: Briefcase,
  building: Building2,
  settings: Settings,
} as const;

export default function BottomNav() {
  const location = useLocation();
  const { viewMode, setViewMode, portalPack } = useViewMode();

  const navItems = useMemo(() => {
    const home = {
      id: "home" as const,
      label: "Home",
      icon: Home,
      path: "/dashboard",
      onClick: () => setViewMode("home"),
      isActive: viewMode === "home" && location.pathname === "/dashboard",
    };
    const modes = portalPack.modes.map((mode) => ({
      id: mode.id,
      label: mode.label,
      icon: ICONS[mode.icon] || Users,
      path: "/dashboard",
      onClick: () => setViewMode(mode.id),
      isActive: viewMode === mode.id && location.pathname === "/dashboard",
    }));
    return [home, ...modes];
  }, [portalPack, viewMode, setViewMode, location.pathname]);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-header-bg border-t border-header-border lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive =
            item.isActive !== undefined
              ? item.isActive
              : location.pathname === item.path;

          return (
            <Link
              key={item.id}
              to={item.path}
              onClick={item.onClick}
              className={cn(
                "flex flex-col items-center justify-center w-full h-full gap-1 transition-colors relative",
                isActive
                  ? "text-primary"
                  : "text-header-text-muted hover:text-header-text",
              )}
            >
              <item.icon
                className={cn(
                  "w-5 h-5",
                  isActive && "animate-in zoom-in-75 duration-300",
                )}
              />
              <span className="text-[10px] font-medium truncate px-1">
                {item.label}
              </span>
              {isActive && (
                <span className="absolute bottom-1 w-1 h-1 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
